import { compact, isEmpty } from 'lodash';
import { useState } from 'react';
import { useGetAllLayouts } from 'src/hooks';
import { ILayout, IStatus } from 'src/interfaces';

import { RadioSearchParam } from '../modules/selectLayoutForm/SelectLayoutForm.interface';

export const useSelectLayoutForm = (layoutTypeId: number) => {
  const [selectedLayout, setSelectedLayout] = useState<ILayout>();
  const [searchVal, setSearchVal] = useState<string[]>([]);
  const [radioSearchParam, setRadioSearchParam] = useState<RadioSearchParam>({
    orientation: '',
    num_screens: 0,
  });

  const {
    data: layoutsDetails = { pages: [], pageParams: [] },
    isLoading: isLayoutsLoading,
    error: errorLayouts,
    hasNextPage,
    fetchNextPage,
  } = useGetAllLayouts(
    compact([
      `layout_type_id=${layoutTypeId}`,
      `status=${IStatus.READY}`,
      !isEmpty(searchVal)
        ? `name.regexp=${encodeURIComponent(searchVal.join('|'))}`
        : '',
      radioSearchParam?.num_screens
        ? `num_screens=${radioSearchParam?.num_screens}`
        : '',
      radioSearchParam?.orientation
        ? `orientation=${radioSearchParam?.orientation}`
        : '',
    ]),
  );

  const getNextLayoutPage = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const totalNumOfLayouts = layoutsDetails.pages.reduce((acc, page) => {
    acc += page.layouts.length;

    return acc;
  }, 0);

  return {
    searchVal,
    radioSearchParam,
    selectedLayout,
    totalNumOfLayouts,
    layoutsDetails,
    isLayoutsLoading,
    errorLayouts,
    getNextLayoutPage,
    onSelectedLayout: setSelectedLayout,
    onChangedSearchVal: setSearchVal,
    onChangedRadioSearchParam: setRadioSearchParam,
  };
};
